/**
 * Directional "F Focus!" prompt. When the player is hit, a badge floats near the
 * player model in the SCREEN direction the shot came from, nudging them to press
 * F to lock on and fight back — or to ignore it and run. It fades over its
 * lifetime and hides when the timer runs out.
 *
 * DOM overlay positioned from the player's on-screen point + a screen-space
 * direction the caller computes (world hit-direction rotated by the camera
 * heading). No PixiJS here.
 */

export class FocusPrompt {
  private readonly root: HTMLElement;
  private shown = false;

  constructor(host: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'focus-prompt';
    this.root.style.display = 'none';
    this.root.innerHTML = `<span class="fp-arrow">➤</span><span class="fp-key">F</span><span class="fp-label">Focus!</span>`;
    host.appendChild(this.root);
  }

  /**
   * @param screenX,screenY  the player's on-screen pixel position.
   * @param dirX,dirY  screen-space unit vector toward the attacker.
   * @param alpha  0..1 fade (0 → hidden).
   */
  update(screenX: number, screenY: number, dirX: number, dirY: number, alpha: number): void {
    if (alpha <= 0) {
      if (this.shown) { this.root.style.display = 'none'; this.shown = false; }
      return;
    }
    this.shown = true;
    this.root.style.display = 'flex';
    const R = 64; // px from the player toward the attacker
    this.root.style.left = `${screenX + dirX * R}px`;
    this.root.style.top = `${screenY + dirY * R}px`;
    this.root.style.opacity = `${alpha}`;
    // Rotate the arrow to point outward (from the player toward the attacker).
    const deg = (Math.atan2(dirY, dirX) * 180) / Math.PI;
    const arrow = this.root.querySelector('.fp-arrow') as HTMLElement | null;
    if (arrow) arrow.style.transform = `rotate(${deg}deg)`;
  }
}
